var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgNotificationAlertRed = function SvgNotificationAlertRed(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    fill: "#E01032"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M12.792 22.211c0 1.17.936 2.132 2.21 2.132 1.3 0 2.236-.962 2.236-2.132 0-1.196-.936-2.158-2.236-2.158-1.274 0-2.21.962-2.21 2.158M14.82 5.363c-1.508 0-1.768.13-1.768.442l.468 11.804c0 .26.26.312 1.196.312h.546c.936 0 1.196-.052 1.196-.312l.416-11.804c0-.312-.26-.442-1.768-.442z"
  })));
};
export { SvgNotificationAlertRed as ReactComponent };
export default __webpack_public_path__ + "images/Notification_Alert_Red.svg";